import React, { useMemo } from 'react'
import { getPropertyName } from '../../helpers/utils'
import BaseElement from './BaseElement'

const InvalidTypeMutator = ({ definition, value, itemKey, buttons }) => {
  const title = useMemo(() => getPropertyName(definition?.title, itemKey), [definition, itemKey])

  return (
    <BaseElement error={!definition}>
      <header-area>
        <span>{title}</span>
        <div>
          {buttons}
        </div>
      </header-area>
      <div>This component is not supported.</div>
      <div>Name: {value?.construtor?.name}</div>
      <div>Value: {value ? value.toString() : 'undefined'}</div>
    </BaseElement>
  )
}

export default InvalidTypeMutator